import { getColumnType } from "utils/helpers";
import {
  columnDataType,
  dateTypeEnum,
  numberTypeEnum,
  textTypeEnum,
} from "utils/types";
import { v4 } from "uuid";

export class ColorSidebarService {
  static colorItemsOptionsObject = {
    [columnDataType.text]: [
      {
        key: textTypeEnum.predictValue,
        value: "Model values",
        hasInput: false,
        hasSecondInput: false,
        hasDropdown: true,
      },
      {
        key: textTypeEnum.uniqueValue,
        value: "unique value",
        hasInput: false,
        hasSecondInput: false,
        hasDatepicker: false,
        hasSecondDatepicker: false,
      },
      {
        key: textTypeEnum.empty,
        value: "empty",
        hasInput: false,
        hasSecondInput: false,
        hasDatepicker: false,
        hasSecondDatepicker: false,
      },
      {
        key: textTypeEnum.notEmpty,
        value: "not empty",
        hasInput: false,
        hasSecondInput: false,
        hasDatepicker: false,
        hasSecondDatepicker: false,
      },
      {
        key: textTypeEnum.textContains,
        value: "text contains",
        hasInput: true,
        hasSecondInput: false,
        hasDatepicker: false,
        hasSecondDatepicker: false,
      },
      {
        key: textTypeEnum.textDoesNotContain,
        value: "text does not contain",
        hasInput: true,
        hasSecondInput: false,
        hasDatepicker: false,
        hasSecondDatepicker: false,
      },
      {
        key: textTypeEnum.textStartsWith,
        value: "text starts with",
        hasInput: true,
        hasSecondInput: false,
        hasDatepicker: false,
        hasSecondDatepicker: false,
      },
      {
        key: textTypeEnum.textEndsWith,
        value: "text ends with",
        hasInput: true,
        hasSecondInput: false,
        hasDatepicker: false,
        hasSecondDatepicker: false,
      },
      {
        key: textTypeEnum.textIsExactly,
        value: "text is exactly",
        hasInput: true,
        hasSecondInput: false,
        hasDatepicker: false,
        hasSecondDatepicker: false,
      },
    ],
    [columnDataType.date]: [
      {
        key: dateTypeEnum.predictValue,
        value: "Model values",
        hasInput: false,
        hasSecondInput: false,
        hasDropdown: true,
      },
      {
        key: dateTypeEnum.uniqueValue,
        value: "unique value",
        hasInput: false,
        hasSecondInput: false,
      },
      {
        key: dateTypeEnum.empty,
        value: "empty",
        hasInput: false,
        hasSecondInput: false,
      },
      {
        key: dateTypeEnum.notEmpty,
        value: "not empty",
        hasInput: false,
        hasSecondInput: false,
      },
      {
        key: dateTypeEnum.dateIs,
        value: "date is",
        hasDatepicker: true,
        hasSecondDatepicker: false,
      },
      {
        key: dateTypeEnum.dateIsBefore,
        value: "date is before",
        hasInput: false,
        hasSecondInput: false,
        hasDatepicker: true,
        hasSecondDatepicker: false,
      },
      {
        key: dateTypeEnum.dateIsAfter,
        value: "date is after",
        hasInput: false,
        hasSecondInput: false,
        hasDatepicker: true,
        hasSecondDatepicker: false,
      },
      {
        key: dateTypeEnum.isBetween,
        value: "is between",
        hasInput: false,
        hasSecondInput: false,
        hasDatepicker: true,
        hasSecondDatepicker: true,
      },
      {
        key: dateTypeEnum.isNotBetween,
        value: "is not between",
        hasInput: false,
        hasSecondInput: false,
        hasDatepicker: true,
        hasSecondDatepicker: true,
      },
    ],
    [columnDataType.number]: [
      {
        key: numberTypeEnum.uniqueValue,
        value: "unique value",
        hasInput: false,
        hasSecondInput: false,
      },
      {
        key: numberTypeEnum.empty,
        value: "empty",
        hasInput: false,
        hasSecondInput: false,
      },
      {
        key: numberTypeEnum.notEmpty,
        value: "not empty",
        hasInput: false,
        hasSecondInput: false,
      },
      {
        key: numberTypeEnum.moreThan,
        value: "more than",
        hasInput: true,
        hasSecondInput: false,
        hasDatepicker: false,
        hasSecondDatepicker: false,
      },
      {
        key: numberTypeEnum.moreThanOrEqualTo,
        value: "more than or equal to",
        hasInput: true,
        hasSecondInput: false,
        hasDatepicker: false,
        hasSecondDatepicker: false,
      },
      {
        key: numberTypeEnum.lessThan,
        value: "less than",
        hasInput: true,
        hasSecondInput: false,
        hasDatepicker: false,
        hasSecondDatepicker: false,
      },
      {
        key: numberTypeEnum.lessThanOrEqualTo,
        value: "less than or equal to",
        hasInput: true,
        hasSecondInput: false,
        hasDatepicker: false,
        hasSecondDatepicker: false,
      },
      {
        key: numberTypeEnum.equal,
        value: "equal",
        hasInput: true,
        hasSecondInput: false,
        hasDatepicker: false,
        hasSecondDatepicker: false,
      },
      {
        key: numberTypeEnum.notEqual,
        value: "not equal",
        hasInput: true,
        hasSecondInput: false,
        hasDatepicker: false,
        hasSecondDatepicker: false,
      },
      {
        key: numberTypeEnum.isBetween,
        value: "is between",
        hasInput: true,
        hasSecondInput: true,
        hasDatepicker: false,
        hasSecondDatepicker: false,
      },
      {
        key: numberTypeEnum.isNotBetween,
        value: "is not between",
        hasInput: true,
        hasSecondInput: true,
        hasDatepicker: false,
        hasSecondDatepicker: false,
      },
    ],
    [columnDataType.checkbox]: [
      {
        key: dateTypeEnum.notEmpty,
        value: "is set",
        hasInput: false,
        hasSecondInput: false,
      },
      {
        key: dateTypeEnum.empty,
        value: "not set",
        hasInput: false,
        hasSecondInput: false,
      },
    ],
  };

  static createHeaderOptions(headers, tableTypes) {
    return headers.map((header, index) => {
      const headerItemType = getColumnType(tableTypes[index]);
      return {
        key: index,
        value: header,
        type: headerItemType,
      };
    });
  }

  static createColorItemSetting(columnType) {
    const newItemObject = {
      id: v4(),
      type: columnType,
      options: this.colorItemsOptionsObject[columnType],
      color: null,
      inputsDataArray: [],
      selectedOption: null,
    };

    return newItemObject;
  }

  static createColorSchemeConditions(colorItems) {
    const conditions = [];

    colorItems.forEach((colorItem) => {
      if (colorItem?.selectedOption?.key) {
        conditions.push({
          type: colorItem?.selectedOption?.key,
          inputsDataArray: colorItem.inputsDataArray,
          color: colorItem.color,
        });
      }
    });

    return conditions;
  }

  static createColorScheme({
    colorSchemeType,
    colorColumn,
    colorColumnType,
    currentOpenTabId,
    isPrimaryColumn = false,
    colorItems = null,
    gradientData = null,
  }) {
    const conditions = this.createColorSchemeConditions(colorItems);

    return {
      colorSchemeType,
      colorColumn,
      currentOpenTabId,
      isPrimaryColumn,
      colorColumnType,
      colorSchemeGradientData: gradientData,
      colorSchemeConditionsData: {

        conditions: conditions,
      },
    };
  }
}
